<!--左边菜单  -->
<template>
  <el-menu
    :collapse="collapsed"
    collapse-transition
    :default-active="$route.path"
    unique-opened
    class="el-menu-vertical-demo"
    background-color="#334157"
    text-color="#fff"
  >
    <div class="logobox">保e投PC端出单平台</div>
    <!-- 遍历路由表，生成左侧菜单 -->
    <template v-for="(item, index) in menus" v-if="!item.hidden">
      <!-- 一级菜单的情况 -->
      <template v-if="item.type == 'item'">
        <router-link :to="item.index">
          <!--index跟浏览器地址对应，这样菜单才能显示选中状态  -->
          <el-menu-item :index="item.index">
            <!-- 设置icon -->
            <i v-if="item.meta.icon" :class="item.meta.icon"></i>
            <!-- 菜单名称 -->
            <span slot="title">{{ item.meta.title }}</span>
          </el-menu-item>
        </router-link>
      </template>
      <!-- 一级菜单的情况 end-->
      <!-- 多级菜单 -->
      <template v-else>
        <el-submenu :index="item.path">
          <template slot="title">
            <i :class="item.meta.icon"></i>
            <span>{{ item.meta.title }}</span>
          </template>
          <!-- 遍历子菜单 -->
          <template
            v-for="(itemChild, indexChild) in item.children"
            v-if="itemChild.meta.requireAuth"
          >
            <!-- 当发现存在3级或大于3级菜单时,重新遍历当前组件 -->
            <template
              v-if="itemChild.children && itemChild.children.length > 0"
            >
              <side-meuns :routes="[itemChild]" class="nest-menu"></side-meuns>
            </template>
            <!-- 2级菜单时-->
            <template v-else>
              <!-- <router-link :to="itemChild.path"> -->
              <el-menu-item :index="itemChild.path">
                <i v-if="itemChild.meta.icon" :class="itemChild.meta.icon"></i>
                {{ itemChild.meta.title }}
              </el-menu-item>
              <!-- </router-link> -->
            </template>
          </template>
          <!-- 遍历子菜单 end-->
        </el-submenu>
      </template>
      <!-- 多级菜单 end-->
    </template>
  </el-menu>
</template>
<script>
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
    };
  },
  watch: {},
  computed: {
    menus() {
      console.log(
        this.$store.state.sidebarRouters,
        "menus",
        this.formatter(this.$store.state.sidebarRouters)
      );
      return this.formatter(this.$store.state.sidebarRouters);
    },
  },
  created() {
    if (this.$route.query.token || localStorage.getItem("token")) {
      this.$store.commit(
        "login",
        this.$route.query.token || localStorage.getItem("token")
      );
      this.$store.dispatch("getUserInfo");
    }
    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      this.collapsed = !value;
    });
  },
  methods: {
    formatter(routes) {
      return routes.map((route) => {
        // 获取可见子菜单项
        const visibleChildren = Array.isArray(route.children)
          ? route.children.filter((child) => {
              // 安全处理 meta，防止 meta 为 null/undefined
              const meta = child.meta || {};
              return !meta.hidden && meta.requireAuth !== false;
            })
          : [];

        if (visibleChildren.length <= 1) {
          if (visibleChildren.length === 1) {
            return {
              ...route,
              type: "item",
              index: visibleChildren[0].path,
              component: visibleChildren[0].component,
              meta: visibleChildren[0].meta,
            };
          } else {
            return { ...route, type: "item", index: route.path };
          }
        } else {
          return {
            ...route,
            type: "submenu",
            children: visibleChildren.map((child) => ({
              index: child.path,
              title: child.meta.title,
              component: child.component,
              meta: child.meta,
            })),
          };
        }
      });
    },
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  /* background-color: #1f2d3d !important; */
}

.el-menu {
  border: none;
}

.logobox {
  height: 60px;
  line-height: 60px;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  /*padding: 20px 0px;*/
  font-weight: 800;

  white-space: nowrap;
  /* 确保文本不会换行 */
  overflow: hidden;
  /* 隐藏超出容器的文本 */
  text-overflow: ellipsis;
  /* 当文本超出容器时显示省略号 */
  min-width: 70px;
  /* 设置一个宽度，你可以根据需要调整 */
}

.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue